import axios from 'axios';
import { ApiRequest, Builder } from 'laravel-request';
import { NotifyManager } from 'notify-component';
import LocalStorageHelper from '#app/helpers/Cache/LocalStorageHelper';
import moment from 'moment';
import { Url } from 'finhelper';
import { isMaintenanceError, emitMaintenanceDetected } from '#app/helpers/maintenanceMode';

Error.stackTraceLimit = 30;

// Логирование ошибок API до обработки в laravel-request и TanStack Query
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isMaintenanceError(error)) {
      // eslint-disable-next-line no-console -- диагностика события включения maintenance-mode
      console.warn('[maintenance][detected]', error?.config?.url, error?.response?.status);
      // Ставим pending-флаг + шлем событие, чтобы не терять ранний maintenance при старте приложения.
      emitMaintenanceDetected();
    }

    // eslint-disable-next-line no-console -- централизованное логирование ошибок запросов
    console.error('[API error]', error?.config?.url ?? error?.config, error?.message ?? error);
    return Promise.reject(error);
  }
);

ApiRequest.notifyClass = NotifyManager;

Builder.availableMethod = [
  ...Builder.availableMethod,
  ...[
    'whereAccount',
    'whereIncomeType',
    'whereSalaryType',
    'whereSpendingType',
    'whereObligationType',
    'wherePropertyType',
    'whereInvestType',
    'whereCurrencyType',
    'whereAccountType',
    'whereInsuranceType',
    'searchInRelatedCatalogs',
  ],
];

const setLanguage = (langId, locale) => {
  localStorage.setItem(LocalStorageHelper.LANGUAGE, langId);
  moment.locale(locale);
};

const url = Url.getCurrentUrl();
const lang = localStorage.getItem(LocalStorageHelper.LANGUAGE);

if (url.includes('/ru/')) {
  setLanguage(1, 'ru');
  window.i18n = {};
} else if (url.includes('/en/')) {
  setLanguage(2, 'en');
} else if (parseInt(lang) === 1 || lang === null) {
  moment.locale('ru');
  window.i18n = {};
} else {
  moment.locale('en');
}
